import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledPath = styled.path`
  ${({ gFill, theme }) =>
    `fill: ${typeof gFill === 'function' ? gFill(theme) : gFill}`}
`;

const IconAppMenu = ({ fill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    version="1.1"
    viewBox="0 0 36 36"
    xlink="http://www.w3.org/1999/xlink"
  >
    <StyledPath
      d="M18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0zm-3.75 18.625h-3.125l-.177.005A3.129 3.129 0 0 0 8 21.75v3.125l.005.177A3.129 3.129 0 0 0 11.125 28h3.125l.177-.005a3.129 3.129 0 0 0 2.948-3.12V21.75l-.005-.177a3.129 3.129 0 0 0-3.12-2.948zm10.625 0H21.75l-.177.005a3.129 3.129 0 0 0-2.948 3.12v3.125l.005.177A3.129 3.129 0 0 0 21.75 28h3.125l.177-.005A3.129 3.129 0 0 0 28 24.875V21.75l-.005-.177a3.129 3.129 0 0 0-3.12-2.948zM14.25 8h-3.125l-.177.005A3.13 3.13 0 0 0 8 11.125v3.125l.005.177a3.13 3.13 0 0 0 3.12 2.948h3.125l.177-.005a3.13 3.13 0 0 0 2.948-3.12v-3.125l-.005-.177A3.13 3.13 0 0 0 14.25 8zm10.625 0H21.75l-.177.005a3.13 3.13 0 0 0-2.948 3.12v3.125l.005.177a3.129 3.129 0 0 0 3.12 2.948h3.125l.177-.005A3.129 3.129 0 0 0 28 14.25v-3.125l-.005-.177A3.13 3.13 0 0 0 24.875 8z"
      gFill={fill}
      fillRule="evenodd"
    />
  </svg>
);

IconAppMenu.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

IconAppMenu.defaultProps = {
  width: '34',
  height: '34',
  fill: 'white',
};

export default IconAppMenu;
